export default {
  esg_dashboard: {
    title: 'Dashboard',
  },
  improvement_plans: {
    title: 'Improvement Plan',
  },
  question_group_section: {
    card_title: 'Unanswered surveys',
    list_header_buyer_company_name: 'Buyer',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: 'Deadline',
    list_header_status: 'Status',
    number_of_answered_label: 'Answered questions',
    number_of_answered_unit: '',
    number_of_answered: 'In progress： {answered}/{total}',
    status_re_answer_request: 'Withdrawal request in progress',
    answer: 'Answer',
    withdrawn: 'Withdrawn',
    no_survey_response_requests_text_1:
      'There are no survey requests available.\nIf you wish to request a response, please ',
    contact: 'contact us',
    no_survey_response_requests_text_2: '.',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: 'Buyer',
    list_header_question: 'Survey',
    list_header_create_at: 'Date issued',
    list_header_deadline: 'Date of expiry',
    list_header_status: 'Status',
    limit_one_year: 'One year from the date issued',
    esg_score: 'ESG Score',
    esg_rating: 'ESG Rating',
    detail: 'Detail',
  },
  faq_section: {
    card_title: 'FAQs',
    faq_why_request: {
      question:
        'Why did I receive a survey through ASUENE ESG from a business partner?',
      answer:
        'In recent years, sustainable procurement has been a significant trend, and companies are required to operate business considering ESG-relateds issues throughout their supply chain. Companies not only needs to check and disclose their own ESG activities, but are required to check and encourage its business partners to take action related to ESG activities.',
    },
    faq_what_benefit: {
      question: 'What are the benefits of answering ASUENE ESG?',
      answer:
        "There are three benefits of answering a survey through ASUENE ESG. \n1) Understand your company's strengths and weaknesses regarding ESG \n2) Compare your company’s assessment with other companies in your industry \n3) Promote your company’s ESG activities by disclosnig the results of your assessment",
    },
    list: 'View List',
  },
  contact_section: {
    card_title: 'Contact us',
    description:
      'If you have any questions about the survey or how to answer, please feel free to contact us at any time.\nIf you would like to receive more specific support for improving ESG activities, you can ask for support from our consultant.',
    inquiry: 'Contact us',
  },
}
